var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeArrowLeftGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16634 9.33333L12.9997 2.75C13.1663 2.58333 13.333 2.5 13.583 2.5C14.083 2.5 14.4163 2.91667 14.4163 3.33333C14.4163 3.58333 14.333 3.75 14.1663 3.91667L7.91634 10L14.1663 16C14.333 16.1667 14.4163 16.4167 14.4163 16.6667C14.4163 17.1667 13.9997 17.5 13.583 17.5C13.333 17.5 13.1663 17.4167 12.9997 17.25L6.16634 10.6667C5.99967 10.5 5.83301 10.25 5.83301 10C5.83301 9.75 5.99967 9.5 6.16634 9.33333Z",
    fill: "url(#paint0_linear_1705_107914)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1705_107914",
    x1: 5.83301,
    y1: 10.0005,
    x2: 14.4163,
    y2: 10.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeArrowLeftGold);
export default __webpack_public_path__ + "static/media/Home_Arrow_Left_Gold.c5e443048b1dc1ca2bf7c4ea51b9c10e.svg";
export { ForwardRef as ReactComponent };